import React, { useEffect, useState } from 'react';
import Group from './Group';
import { Breadcrumb, Col, Container, Row } from 'react-bootstrap';
import { ChevronLeft } from 'react-bootstrap-icons';
import ItemView from './ItemView';
import { useAppContext } from 'contexts/AppContext';

const GroupView = ({ baseFilters, setBaseFilters, levels }) => {
  // contexts
  const { appState } = useAppContext();

  // states
  const [groups, setGroups] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [history, setHistory] = useState([
    {
      id: 0,
      name: 'root',
      abstract: true,
    },
  ]);
  const [abstract, setAbstract] = useState(true);

  // hooks

  // functions
  const view = (group, baseFilters) => {
    setHistory((history) => [...history, group]);
    setAbstract(group.abstract);
    if (group.abstract && group.id === 0)
      setFilteredGroups(allGroups.filter((x) => !x.parentGroup), baseFilters);
    else if (group.abstract && group.id !== 0)
      setFilteredGroups(allGroups.filter((x) => x.parentGroup?.id === group.id), baseFilters);
  };

  const jumpTo = (group, baseFilters) => {
    const hist = history;
    while (hist.length && hist[hist.length - 1].id !== group.id) history.pop();
    view(history.pop(), baseFilters);
  };

  const currentGroup = () => history[history.length - 1];

  const setFilteredGroups = (groups, baseFilters) => {
    // Preparing filter ingridients
    const builderGroups = appState.resources.itemGroups;
    const includedItemGroups = baseFilters.itemGroups.map(x => x.value);
    const excludedItemGroups = baseFilters.excludedItemGroups.map(x => x.value);

    const checkFilterTree = (itemGroup) => {
      let l1 = includedItemGroups.length ? includedItemGroups.some(group => group.id == itemGroup?.id) : true;
      if (!l1 && itemGroup?.parentGroup) {
        // parent checking
        let parent = getParentGroup(itemGroup);
        while (parent && !l1) {
          l1 = includedItemGroups.some(group => group.id == parent.id);
          parent = getParentGroup(parent);
        }
      }
      if (!l1) {
        // children check
        for (const subGroup of builderGroups.filter(g => g.parentGroup?.id === itemGroup.id)) {
          l1 = checkFilterTree(subGroup);
          if (l1) break;
        }
      }

      let l2 = excludedItemGroups.length ? !excludedItemGroups.some(group => group.id == itemGroup?.id) : true;

      return l1 && l2;
    };

    setGroups(groups.filter(group => checkFilterTree(group)));
  };

  const getParentGroup = (group) => {
    return appState.resources.itemGroups.find(g => g.id == group?.parentGroup?.id);
  };

  // effects
  useEffect(() => {
    const groups = appState.resources.itemGroups;
    setFilteredGroups(groups.filter((x) => !x.parentGroup), baseFilters);
    setAllGroups(groups);
  }, [appState.resources.itemGroups, baseFilters]);

  return (
    <React.Fragment>
      <Container fluid className='my-2'>
        <Row>
          <Breadcrumb className='m-0'>
            <Breadcrumb.Item
              key={-1}
              active
              onClick={() => jumpTo(history[Math.max(0, history.length - 2)], baseFilters)}
              className='h6'
            >
              <ChevronLeft
                size={30}
                className='border rounded-circle p-2 cursor-pointer'
              />
            </Breadcrumb.Item>
            {history.map((x, index) => (
              <Breadcrumb.Item
                key={x.id}
                active={index === history.length - 1}
                onClick={() => jumpTo(x, baseFilters)}
                className='h6 d-flex align-items-center'
              >
                {x.name}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </Row>
        <Row className='my-2'>
          {abstract &&
            groups.map((group) => (
              <Col key={group.id} sm={12} md={4} lg={3} className='my-2'>
                <Group group={group} onView={(group) => view(group, baseFilters)} />
              </Col>
            ))}
          {!abstract && (
            <ItemView key={currentGroup().id} group={currentGroup()} baseFilters={baseFilters} setBaseFilters={setBaseFilters} levels={levels} />
          )}
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default GroupView;
